export default "__VITE_ASSET__d4a96491__"